export const THEME = {
	LIGHT: {
		PRIMARY_COLOR: '#3d5fff'
	},
	DARK: {
		PRIMARY_COLOR: '#506ff8'
	},
	WHITE: '#ffffff',
	BLACK: '#000000',
	LORDICON_STROKE: 70
};
